const de = {
  hello: 'hello',
  welcome: 'Willkommen zurück!',
  emailusername: 'Email/Benutzername',
  password: 'Passwort',
  signdescription:
    'Finde die besten Behandlungsmethoden für Dein Problem oder hilf anderen mit Deinen Erfahrungen!',
  remember: 'Angemeldet bleiben',
  forgot: ' Passwort vergessen?',
  signbtn: 'Anmeldung',
  google: 'Weiter mit Google',
  facebook: 'Weiter mit Facebook',
  // Signup
  getstart: 'Herzlich Willkommen!',
  signupdescription:
    'Registriere Dich mit einer gültigen Email Adresse und erstelle ein Passwort oder melde Dich über Google bzw. Facebook an.',
  signupbtn: 'WEITER',
  required: 'Eingabe erforderlich',
  mincharacters4: 'Mindestens 4 Zeichen erforderlich',
  mincharacters8: 'Mindestens 8 Zeichen erforderlich',
  mincharacters2: 'Mindestens 2 Zeichen erforderlich',

  // Add information
  addinfo: 'Noch ein paar Infos ...',
  addinfo_details:
    'Hinweis: Der Benutzername bietet Dir die Möglichkeit, zu sensiblen Themen schreiben zu können ohne Deine Identität preisgeben zu müssen.',
  fname: 'Vorname',
  lname: 'Nachname',
  username: 'Benutzername ',
  dob: 'Geburtsdatum',
  gender: 'Geschlecht',
  male: 'männlich',
  female: 'weiblich',
  almostdone: 'FAST FERTIG...',
  uploadprofile: 'Peppe dein Profil auf ...',
  uploadprofile_details:
    'Wir sind eine Gemeinschaft. Wir alle sind Menschen. Zeig Dich :)',
  imgupload: 'Profilbild hochladen',
  finished: 'GESCHAFFT!',
  // upload post

  uploadpost: 'Beitrag erstellen',
  uploadposthead: 'FÜGE DEINE ERFAHRUNG HINZU',
  symptoms: 'Zu welchem Thema hast Du Erfahrungen gemacht?',
  addsymptoms: 'Nenne uns den Namen des Symptoms oder der Krankheit',
  whathelped: 'Was hat Dir geholfen?',
  meanspreparation: 'MITTEL / PRÄPARAT',
  meanspreparation_placeholder:
    'Was hast du eingenommen oder äußerlich angewendet?',

  therapyactivity: 'THERAPIE / AKTIVITÄT',
  therapyactivity_placeholder:
    'Welche Therpie oder Aktivität hat Dir geholfen?',
  professionals: 'FACHLEUTE',
  professionals_placeholder:
    'Nenne uns den Namen des Arztes, Coaches, Berater oder der Klinik!',
  address_placeholder: 'Adresse',
  others: 'ETWAS ANDERES',
  others_placeholder: 'Was oder welche Methode hat Dir sonst geholfen?',
  treatmentsuccess: 'Wie erfolgreich war Deine Behandlung?',

  ratetreatment:
    'Bitte bewerte den Erfolg Deiner Behandlung: 1  für gering - 5 für exzellent',
  informationaffected: 'Hast Du noch mehr Informationen für Betroffene?',
  informationaffected_placeholder:
    'Erzähle mehr über Deine gemachten Erfahrungen und gib damit anderen Menschen Perspektiven und Hilfe. Dankeschön!',
  back: 'ZURÜCK',
  next: 'WEITER',
  finish: 'BEITRAG ERSTELLEN',

  // sidebar
  home: 'Startseite',
  thema: 'Thema',
  post: 'Beitrag erstellen',

  //
  lang: 'german',
};

export default de;
